import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { TaxesService } from '../_services/taxes.service';

@Component({
    selector: 'app-taxes-list',
    templateUrl: './taxes-list.component.html',
    styleUrls: ['./taxes-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TaxesListComponent implements OnInit {
  public taxes: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private taxesService: TaxesService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService
  ) {
   
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Impuestos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowWrite = true;
    this.allowDelete = true;
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(tax: any) {
    this.router.navigate(['taxes/' + (tax && Object.keys(tax).length > 0 ? tax.id : 0)]);
  }

  delete(tax: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el tipo de impuesto "+tax.name+"?",
        header: "Eliminar tipo de impuesto",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.taxesService.delete(tax.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de impuesto eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
